import React from "react";

export const AuthenContext = React.createContext<{
  apiToken?: string | null;
  login?: boolean | null;
} | null>(null);

export const AuthenProvider = AuthenContext.Provider;
export const AuthenConsumer = AuthenContext.Consumer;
